import logo from "../../../../medias/logoAlpha.png";
import { GetUserResponse } from "../../../../api/";
import { Group, InputButton } from "../../../../components/";
import { ProfileMenu } from "./ProfileMenu";
import { styles, sxStyles } from "../../../../theme/";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Typography, useMediaQuery, useTheme } from "@mui/material";
import CustomSwitch from "./CustomSwitch";
const HOME_COACH = `/${process.env.REACT_APP_HOME_COACH}`;

interface Props {
  userData?: GetUserResponse | undefined;
}

/**
 * Menu component
 */
export const Menu = ({ userData }: Props) => {
  // const profile: UserProfile | undefined = userData && userData.profiles ? userData.profiles[0] : undefined;

  // Hooks
  const navigate = useNavigate();
  const location = useLocation();

  const pathname = location.pathname;
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const handleAnchorClick = (event: React.MouseEvent, anchorId: string) => {
    event.preventDefault();
    const element = document.getElementById(anchorId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <Container style={styles.navBarMenu}>
        <div
          onClick={() => navigate(`${HOME_COACH}`)}
          style={
            isDesktop
              ? {
                  transform: "translateX(-100px) translateY(5px)",
                }
              : {
                  marginRight: "90px",
                  padding: 0,
                  transform: "translateX(15px)",
                }
          }
        >
          <img src={logo} style={{ width: 200, left: "100px" }} alt="OP Club" />
        </div>
        {isDesktop ? (
          <>
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -25%)",
                display: "flex", // Adiciona Flexbox
                justifyContent: "center", // Centraliza os elementos horizontalmente
                alignItems: "center", // Centraliza os elementos verticalmente
                // gap: "20px", // Ajuste o espaçamento entre os elementos conforme necessário
                width: "auto", // Ajuste a largura conforme necessário
                maxWidth: "100%", // Ajusta a largura máxima conforme necessário
                padding: "0 20px", // Adiciona um padding para evitar que os elementos toquem as bordas
                flexDirection: "column",
              }}
            >
              <div>
                <Typography
                  component="a"
                  href="#functionalities"
                  sx={sxStyles.anchor()}
                  onClick={(e) => handleAnchorClick(e, "functionalities")}
                >
                  Funcionalidades
                </Typography>
                <Typography
                  component="a"
                  href="#prices"
                  sx={sxStyles.anchor()}
                  onClick={(e) => handleAnchorClick(e, "prices")}
                >
                  Preços
                </Typography>
                <Typography
                  component="a"
                  href="#about-us"
                  sx={sxStyles.anchor()}
                  onClick={(e) => handleAnchorClick(e, "about-us")}
                >
                  Sobre nós
                </Typography>
              </div>
            </div>
          </>
        ) : (
          <div></div>
        )}
        {userData ? (
          <ProfileMenu userData={userData} />
        ) : (
          <Group
            direction={"row"}
            style={
              isDesktop
                ? {
                    width: 160,
                    padding: 0,
                    margin: 0,
                  }
                : {
                    width: 160,
                    padding: 0,
                    margin: 0,
                    transform: "translateX(-20px)",
                  }
            }
          >
            <InputButton
              type={"primary"}
              style={
                isDesktop
                  ? {
                      height: 40,
                      // marginRight: "20px",
                      transform: "translateX(100px)",
                    }
                  : {
                      transform: "translateX(-10px)",
                      // marginRight: "20px",
                      // width: "140px",
                      height: 40,
                    }
              }
              onClick={() => navigate(`/signIn?to=${pathname}`)}
              tooltip="Access"
            >
              Sign In
            </InputButton>
          </Group>
        )}
      </Container>
      <div><CustomSwitch/></div>
    </>
  );
};
